// Permanent profile link: /u/<code>/<username>. The code (profiles.short_code, random, unique, never changes)
// identifies the account; the username segment is only there to read nicely and may be stale - the page
// replaces it with the current one. See app/u/[first]/[second]/page.tsx.
export const PROFILE_CODE_RE = /^[a-hj-km-np-z2-9]{6}$/

export function profileHref(code: string | null | undefined, username?: string | null, fallbackId?: string): string {
  if (code) return `/u/${code}/${encodeURIComponent(username || "profile")}`
  // No code on hand: the legacy id route still works and redirects to the permanent link.
  return fallbackId ? `/profile/${fallbackId}` : "/"
}
